import React, { useEffect } from 'react'
import { ChevronRightIcon, CogIcon } from '@heroicons/react/24/solid';
import "./../App.css"
import { Link } from "react-router-dom";

const Admin = () => {

    // useEffect(() => {
    //     if (!isAdmin) {
    //         window.location.replace("/");
    //     }
    // }, [])

    return (
        <div style={{ marginBottom: "40px" }}>
            <div className='admin-header'>
                <CogIcon className="" style={{ width: '32px' }} />
                <p style={{ marginBottom: '0' }} className=' text-6xl'>Admin Settings</p>
            </div>

            <div className='user-settings' style={{ marginTop: '20px' }}>
                <p style={{ marginBottom: '0', backgroundColor: "#3b3b3b", color: "#fff", textTransform: "uppercase", padding: "5px 15px", borderRadius: "8px 8px 0 0 " }}>user settings</p>
                <Link to="/admin/user-management" style={{ display: "flex", justifyContent: "space-between", padding: "15px" }}>
                    <div>
                        <p style={{ marginBottom: '0', color: "black", fontWeight: "600", fontFamily: "Poppins" }}>User Management</p>
                        <p style={{ marginBottom: '0', color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Update or disable user accounts</p>
                    </div>
                    <ChevronRightIcon style={{ width: '16px', color: "#000", fontWeight: "bold" }} />
                </Link>
            </div>

            <div className='user-settings' style={{ marginTop: '20px' }}>
                <p style={{ marginBottom: '0', backgroundColor: "#3b3b3b", color: "#fff", textTransform: "uppercase", padding: "5px 15px", borderRadius: "8px 8px 0 0 " }}>rewards & badges settings</p>
                <Link to="/admin/manage-rewards" style={{ display: "flex", justifyContent: "space-between", margin: "15px 15px 0", paddingBottom: "15px", borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
                    <div>
                        <p style={{ marginBottom: '0', color: "black", fontWeight: "600", fontFamily: "Poppins" }}>Manage Rewards</p>
                        <p style={{ marginBottom: '0', color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Add and manage rewards/perks and reward requests</p>
                    </div>
                    <ChevronRightIcon style={{ width: '16px', color: "#000", fontWeight: "bold" }} />
                </Link>
                <Link to="/admin/core-values-awards" style={{ display: "flex", justifyContent: "space-between", padding: "15px" }}>
                    <div>
                        <p style={{ marginBottom: '0', color: "black", fontWeight: "600", fontFamily: "Poppins" }}>Core Values & Awards</p>
                        <p style={{ marginBottom: '0', color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Create and manage core values and awards</p>
                    </div>
                    <ChevronRightIcon style={{ width: '16px', color: "#000", fontWeight: "bold" }} />
                </Link>
            </div>

            {/* <div className='user-settings' style={{ marginTop: '20px' }}>
                <p style={{ marginBottom: '0', backgroundColor: "#3b3b3b", color: "#fff", textTransform: "uppercase", padding: "5px 15px", borderRadius: "8px 8px 0 0 " }}>brand customization</p>
                <Link to="/admin/user-management" style={{ display: "flex", justifyContent: "space-between", padding: "15px" }}>
                    <div>
                        <p style={{ marginBottom: '0', color: "black", fontWeight: "600", fontFamily: "Poppins" }}>Branding</p>
                        <p style={{ marginBottom: '0', color: "black", fontFamily: "Poppins", fontSize: "12px" }}>Customize Pats based on your company</p>
                    </div>
                    <ChevronRightIcon style={{ width: '16px', color: "#000", fontWeight: "bold" }} />
                </Link>
            </div> */}

        </div>
    )
}

export default Admin